var SLIDE_TRANSITION = {
  ease: 'cubic-bezier(0.46,0.1,0.25,1)'
};
export default SLIDE_TRANSITION;